import React from 'react'
import PropTypes from 'prop-types';
import { Link } from 'gatsby'
import { NEVER_NULL_TAG, SPRINGBOARD_TAG } from 'config/productItems';

const SearchMoreLinks = ({
    currentTag,
    currentVersion,
    pageData
}) => {

    const howToParamBase = `/how-to?q=*%3A*&wt=json&&start=0&rows=10&fq=productName:("${currentTag}")`

    let appOrVersion = ''
    let productChanged = false;

    if(currentTag !== SPRINGBOARD_TAG && currentTag !== NEVER_NULL_TAG){
        appOrVersion = `&fq=productVersion:("${currentVersion}")`
    } else if (pageData?.frontmatter.appType && currentTag !== NEVER_NULL_TAG){
        appOrVersion = `&fq=appType:("${pageData?.frontmatter.appType?.toString().replaceAll(',', '","')}")`
    } else if (currentTag === SPRINGBOARD_TAG){
        productChanged = true
        appOrVersion = `&fq=appType:("${currentVersion}")` // currentVersion is the appType value when springboard is selected
    }

    if(pageData?.frontmatter?.appType && currentTag !== SPRINGBOARD_TAG){
        productChanged = true;
    }

    const personaParam = !productChanged ? `&fq=persona:("${pageData?.frontmatter?.persona.replaceAll(', ', '","')}")` : ''
    const objectiveParam = !productChanged ? `&fq=objective:("${pageData?.frontmatter?.objective.replaceAll(', ', '","')}")` : ''

    return (
        <>
            <li><Link to={`${howToParamBase}${appOrVersion}${personaParam}`}>By User Role</Link></li>
            <li><Link to={`${howToParamBase}${appOrVersion}${objectiveParam}`}>By Objective</Link></li>
            <li><Link to={`${howToParamBase}${appOrVersion}${objectiveParam}${personaParam}`}>By All</Link></li>
        </>
    )
} 

SearchMoreLinks.propTypes = {
    currentTag: PropTypes.string.isRequired,
    currentVersion: PropTypes.string.isRequired,
    pageData: PropTypes.object
}

export default SearchMoreLinks

